export const ALERT_TYPES = Object.freeze({
  DEVICE: "DEVICE",
  NPS: "NPS",
  REFERRAL: "REFERRAL",
});

/**
 * User setting recording that the field management table and map views have been announced. It belongs to the
 * user rather than the farm so that switching farms does not announce them all over again, and it follows the
 * `<feature>AlertDismissals` convention of the other dismissal settings: a count held as a string.
 */
export const FIELD_VIEW_MODE_ALERT_DISMISSALS = "fieldViewModeAlertDismissals";
